// extracted by mini-css-extract-plugin
module.exports = {"container":"wh-z","heading":"xh-z","links":"yh-z","linkBtn":"zh-z","disabled":"Ah-z","linkUppercaseBold":"Bh-z","copy":"Ch-z","subCopy":"Dh-z"};